// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".planEditor[data-v-1aa38e45] {\n  margin-top: 0.2rem;\n}\n.myUeditor[data-v-1aa38e45] .edui-editor {\n  position: sticky;\n  top: 0;\n  height: 600px;\n  overflow: scroll;\n}\n.myUeditor[data-v-1aa38e45] .edui-editor-toolbarbox {\n  position: sticky;\n  top: 0;\n  z-index: 9999;\n}\n", ""]);
// Exports
module.exports = exports;
